var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CreditRules"},[_c('div',{staticClass:"block o-p o-plr-s c-line-10"},[(_vm.main._item)?_c('div',{staticClass:"o-plr",domProps:{"innerHTML":_vm._s(_vm.main._item.content)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }